import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/forma';
import Forma from './Forma';


const ms2p = (state) => {
  return {
    ...state.rs_forma,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Forma);